import { render, staticRenderFns } from "./LeadEdit.vue?vue&type=template&id=f1590e1a&"
import script from "./LeadEdit.vue?vue&type=script&lang=js&"
export * from "./LeadEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports